import { useTranslation } from "react-i18next";
import { useForm } from "@tanstack/react-form";
import { zodValidator } from "@tanstack/zod-form-adapter";
import { Button, Form } from "react-bootstrap";
import { z } from "zod";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { sendForgotPasswordMail } from "../../infrastructure/slices/authSlice/authSlice";
import { toast } from "sonner";
import { useState } from "react";

export const ForgotPasswordForm = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const [sentMail, setSentMail] = useState(false);

  const form = useForm({
    defaultValues: {
      userString: "",
    },
    onSubmit: async (values) => {
      await dispatch(
        sendForgotPasswordMail({ userString: values.value.userString }),
      ).then(() => {
        toast.success(t("user.password.mail.success"));
        setSentMail(true);
      });
    },
    validatorAdapter: zodValidator(),
  });

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        void form.handleSubmit();
      }}
    >
      <h3 className="text-center mb-4">{t("Forgot password")}</h3>
      <form.Field
        name="userString"
        validators={{
          onSubmit: z.string(),
        }}
      >
        {(field) => {
          return (
            <Form.Group>
              <Form.Label>{t("Email")}</Form.Label>
              <Form.Control
                id={field.name}
                name={field.name}
                type="text"
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                isInvalid={field.state.meta.errors.length > 0}
              />
              {field.state.meta.errors ? (
                <Form.Control.Feedback type="invalid">
                  {field.state.meta.errors.join(", ")}
                </Form.Control.Feedback>
              ) : null}
            </Form.Group>
          );
        }}
      </form.Field>
      {!sentMail && (
        <form.Subscribe>
          <Button type="submit" className="mt-4 w-100">
            {t("Send email")}
          </Button>
        </form.Subscribe>
      )}
      <a href="/auth/login">
        <Button className="mt-4 w-100">{t("Back to Login")}</Button>
      </a>
    </Form>
  );
};
